import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import HomeIcon from '@material-ui/icons/Home';
import PageBreadcrumbsItem from '../PageBreadcrumbsItem';

var _ref2 = React.createElement(HomeIcon, null);

var _ref3 = React.createElement(HomeIcon, {
  fontSize: "small",
  color: "action"
});

function PageBreadcrumbsItemHome(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      to = _ref.to,
      rest = _objectWithoutProperties(_ref, ["icon", "label", "to"]);

  var otherProps = React.useMemo(function () {
    return {
      icon: label ? icon || _ref2 : undefined,
      label: label || icon || _ref3,
      to: to || '/'
    };
  }, [icon, label, to]);
  return React.createElement(PageBreadcrumbsItem, _extends({}, rest, otherProps));
}

PageBreadcrumbsItemHome.propTypes = {
  icon: PropTypes.element,
  label: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.string
};
PageBreadcrumbsItemHome.defaultProps = {
  icon: undefined,
  label: undefined,
  onClick: undefined,
  to: undefined
};
export default PageBreadcrumbsItemHome;